import { useAuth } from '@/auth/AuthContext';
import { useCallback } from 'react';

// When running locally, use relative URLs to leverage the proxy configuration
export const apiURL = process.env.NODE_ENV === 'development' ? '/' : process.env.REACT_APP_API_URL;

export const useToken = () => {
  const { getAccessToken } = useAuth();
  const memoizedFn = useCallback(
    async (url: string, options?: any) => {
      const accessToken = await getAccessToken();
      return fetch(url, {
        ...options,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...options?.headers,
          Authorization: `Bearer ${accessToken}`,
        },
      });
    },
    [getAccessToken]
  );
  return {
    privateFetch: memoizedFn,
  };
};
